import React from 'react'

export const StateOfDevsIcon = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="545"
        height="156"
        fill="none"
        viewBox="0 0 545 156"
    >
        <path
            fillRule="evenodd"
            d="M92.823 32.941h29.942v89.824H92.823v29.941H3V3h89.823zm-59.882 89.584h59.882V33.181H32.941zM17.312 7.438v9.58h-9.58v40.72h9.58v-40.72h70.662v-9.58zm89.825 29.94v9.582h-9.581v10.778h9.581V46.96h10.778v-9.581zM242.529 32.941h-59.882v29.942h59.882v29.94h-59.882v29.942h59.882v29.941h-89.823V3h89.823zm-75.51-25.504v9.582h-9.581v40.72h9.581v-40.72h70.661V7.438z"
            clipRule="evenodd"
        ></path>
        <path d="M332.353 152.706h-29.941v-29.941h29.941zM512 152.706h-89.823v-29.941H512z"></path>
        <path
            fillRule="evenodd"
            d="M302.412 122.765h-29.941V3h29.941zm-25.21-105.746v40.72h9.581v-40.72zm9.581-9.581v9.58h10.779v-9.58z"
            clipRule="evenodd"
        ></path>
        <path d="M362.294 122.765h-29.941V62.883h29.941zM541.941 122.765H512V92.823h29.941zM512 92.823h-59.882v-29.94H512z"></path>
        <path
            fillRule="evenodd"
            d="M392.235 62.883h-29.941V3h29.941zM376.607 7.438v9.58h-9.582v40.72h9.582v-40.72h10.779v-9.58zM452.118 62.883h-29.941V32.94h29.941zm-15.629-25.504v9.581h-9.581v10.778h9.581V46.96h10.78v-9.581zM541.941 32.941h-89.823V3h89.823zm-75.51-25.504v9.582h-9.581v10.779h9.581v-10.78h70.661v-9.58z"
            clipRule="evenodd"
        ></path>
    </svg>
)

export default StateOfDevsIcon
